module.exports = __webpack_public_path__ + "img/book1.0e62af3a.webp";